import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from '@/contexts/AuthContext'
import { ToastProvider } from '@/contexts/ToastContext'
import { AnalyticsProvider } from '@/contexts/AnalyticsContext'
import { AnalyticsPageTracker } from '@/components/analytics/AnalyticsPageTracker'
import { ProtectedRoute, PublicRoute } from '@/components/auth/ProtectedRoute'
import { LoginPage } from '@/pages/Login'
import { DashboardPage } from '@/pages/Dashboard'
import { AuthCallbackPage } from '@/pages/AuthCallback'
import { PropertyAnalysis } from '@/pages/PropertyAnalysis'
import { PortfolioPage } from '@/pages/Portfolio'
import { PropertyDetailsPage } from '@/pages/PropertyDetails'
import { RiskAssessmentPage } from '@/pages/RiskAssessment'
import { LogoutSuccessPage } from '@/pages/LogoutSuccess'

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <AnalyticsProvider>
          <Router>
            <AnalyticsPageTracker />
            <Routes>
          {/* Public Routes */}
          <Route
            path="/login"
            element={
              <PublicRoute>
                <LoginPage />
              </PublicRoute>
            }
          />

          {/* Auth Callback Route */}
          <Route
            path="/auth/callback"
            element={<AuthCallbackPage />}
          />

          {/* Logout Success Route */}
          <Route
            path="/logout"
            element={<LogoutSuccessPage />}
          />

          {/* Protected Routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/analyze"
            element={
              <ProtectedRoute>
                <PropertyAnalysis />
              </ProtectedRoute>
            }
          />

          <Route
            path="/portfolio"
            element={
              <ProtectedRoute>
                <PortfolioPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/risk-assessment"
            element={
              <ProtectedRoute>
                <RiskAssessmentPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/property/:propertyId"
            element={
              <ProtectedRoute>
                <PropertyDetailsPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/property/:propertyId/edit"
            element={
              <ProtectedRoute>
                <PropertyAnalysis />
              </ProtectedRoute>
            }
          />

          {/* Root redirect */}
          <Route
            path="/"
            element={<Navigate to="/dashboard" replace />}
          />

          {/* Catch all route - redirect to dashboard */}
          <Route
            path="*"
            element={<Navigate to="/dashboard" replace />}
          />
        </Routes>
          </Router>
        </AnalyticsProvider>
      </ToastProvider>
    </AuthProvider>
  )
}

export default App